import { render, staticRenderFns } from "./IncomeExpense.vue?vue&type=template&id=42a60e62&"
import script from "./IncomeExpense.vue?vue&type=script&lang=js&"
export * from "./IncomeExpense.vue?vue&type=script&lang=js&"
import style0 from "./IncomeExpense.vue?vue&type=style&index=0&id=42a60e62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports